// src/components/AudionAnalysisPanel/AudionAnalysisPanel.styles.ts
import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 40px;
  padding: 32px;
  overflow-y: auto;
  min-height: 0;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: ${getTypography("korean", "body1").fontSize};
  font-weight: ${getTypography("korean", "body1").fontWeight};
  line-height: ${getTypography("korean", "body1").lineHeight};
  letter-spacing: ${getTypography("korean", "body1").letterSpacing};
  color: ${designTokens.colors.font.primary};
`;

// --- Tag List ---
export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Tag = styled.span`
  padding: 4px 10px;
  background: #ffffff;
  border: 1px solid ${designTokens.colors.font.quinary};
  border-radius: 4px;
  font-size: ${getTypography("korean", "body4").fontSize};
  font-weight: ${getTypography("korean", "body4").fontWeight};
  line-height: ${getTypography("korean", "body4").lineHeight};
  letter-spacing: ${getTypography("korean", "body4").letterSpacing};
  color: ${designTokens.colors.font.tertiary};
`;

export const SummaryItem = styled.div`
  padding: 4px 10px;
  background: ${designTokens.colors.box.primary};
  border-radius: 8px;
  font-size: ${getTypography("korean", "body2").fontSize};
  font-weight: ${getTypography("korean", "body2").fontWeight};
  line-height: ${getTypography("korean", "body2").lineHeight};
  letter-spacing: ${getTypography("korean", "body2").letterSpacing};
  color: ${designTokens.colors.font.tertiary};

  /* 강조된 텍스트 스타일 (예시) */
  span {
    font-weight: bold;
    color: ${designTokens.colors.font.primary};
  }
`;

export const ParticipationBar = styled.div`
  display: flex;
  width: 100%;
  height: 42px;
  border-radius: 8px;
  overflow: hidden;
  background: transparent;
`;

interface SegmentProps {
  width: number;
  color: string;
}
export const Segment = styled.div<SegmentProps>`
  flex: 0 0 ${({ width }) => width}%;
  background: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  font-size: ${getTypography("korean", "body4").fontSize};
  font-weight: ${getTypography("korean", "body4").fontWeight};
  line-height: ${getTypography("korean", "body4").lineHeight};
  letter-spacing: ${getTypography("korean", "body4").letterSpacing};
  color: ${designTokens.colors.font.octonary};

  .label {
    white-space: nowrap;
  }
  .percent {
    margin-left: 8px;
  }
`;

// --- Action Bar ---
export const ActionBar = styled.div`
  display: flex;
  gap: 12px;
`;
export const ActionButton = styled.button`
  padding: 8px 12px;
  background: ${designTokens.colors.background.primary};
  border: 1px solid ${designTokens.colors.line.button};
  border-radius: 4px;
  font-size: ${getTypography("korean", "body2").fontSize};
  font-weight: ${getTypography("korean", "body2").fontWeight};
  line-height: ${getTypography("korean", "body2").lineHeight};
  letter-spacing: ${getTypography("korean", "body2").letterSpacing};
  color: ${designTokens.colors.font.primary};
  cursor: pointer;

  &:hover {
    background: ${designTokens.colors.background.primary};
  }
`;
